document.addEventListener('DOMContentLoaded', () => {

  let select = document.querySelector('.recently-viewed select');

  if (select) {
    select.addEventListener('change', (e) =>{
        let contents = document.querySelectorAll('.recently-viewed .tab');
        contents.forEach(content => {
            content.style.display = 'none';
        })
        document.querySelector('.recently-viewed .' + e.target.value).style.display = 'block';
    })
  }

  let tabs = document.querySelectorAll('.recently-viewed .heading-tabs input');

  tabs.forEach(tab => {
      tab.addEventListener('change', (e) => {
          let contents = document.querySelectorAll('.recently-viewed .tab');
          contents.forEach(content => {
              content.style.display = 'none';
          })
          let nav_tabs = document.querySelectorAll('.recently-viewed .swiper-navs');
          nav_tabs.forEach(nav_tab => {
            nav_tab.style.display = 'none';
          })
          const index = e.target.id.slice(-1);
          document.querySelector('.recently-viewed .content' + index).style.display = 'block';
          document.querySelector('.recently-viewed .nav-tab' + index).style.display = 'block';
      })
  })

  const recently_viewed_section = document.querySelector('.recently-viewed');

  const options = {
    rootMargin: '100px'
  }

  const observer = new IntersectionObserver(entry => {

      if (entry[0].isIntersecting == true) {

          observer.unobserve(recently_viewed_section)

          let rec_prods = localStorage.getItem('recentlyViewedProductHandles');
          if (rec_prods) {
              rec_prods_arr = rec_prods.replace("[","").replace("]","").split(',');

              let recently_viewed = document.querySelector('.recently-viewed-slider');

              rec_prods_arr.forEach(rec_prod => {
                  let handle = rec_prod.replace(/"/g,'');

                  fetch(window.Shopify.routes.root + `products/${handle}?section_id=st-product-card`)
                    .then(response => {
                      if (response.ok) {
                        return response.text();
                      } else {
                        throw new Error("Error: " + response.status);
                      }
                    })
                    .then(data => {
                      const htmlDocument = new DOMParser().parseFromString(data, "text/html");
                      const productCard = htmlDocument.documentElement.querySelector("[product-card]");
                      const productExists = productCard.dataset.productId;
                      if (productExists == "") {
                        return;
                      }
                      let url = window.location.href + "#";
                      let swiper_slide = document.createElement("div");
                      swiper_slide.classList.add('swiper-slide');
                      swiper_slide.insertAdjacentHTML('afterbegin', productCard.outerHTML);

                      if (productCard !== url) {
                        recently_viewed.insertAdjacentHTML('afterbegin', swiper_slide.outerHTML);
                      }

                      const recent_swiper = new window.swiper('.recently-swiper', {
                        slidesPerView: 1.2,
                        spaceBetween: 17,

                        navigation: {
                            nextEl: '.nav-tab1 .swiper-navigation--next',
                            prevEl: '.nav-tab1 .swiper-navigation--previous',
                        },

                        lazy: {
                            enabled: true,
                            checkInView: true,
                        },

                        breakpoints: {
                            575: {
                                slidesPerView: 2.2,
                            },
                            768: {
                                slidesPerView: 3.2,
                                spaceBetween: 13
                            },
                            1200: {
                                slidesPerView: 4,
                                spaceBetween: 13
                            }
                        },
                      });
                    })
                    .catch(error => {
                      console.error(error);
                    });

              });

          } else {
              const tab2 = document.querySelector('.recently-viewed #tab2');
              if (tab2) {
                  tab2.checked = true;
              } else {
                  document.querySelector('.recently-viewed').style.display = 'none';
              }
              document.querySelector('.recently-viewed #tab1 + label').style.display = 'none';
              document.querySelector('.recently-viewed .content1').style.display = 'none';
              document.querySelector('.recently-viewed #select-recently-viewed').style.display = 'none';
              document.querySelector('.recently-viewed .select-chevron').style.display = 'none';
              document.querySelector('.recently-viewed .custom-select').style.pointerEvents = 'none';
              document.querySelector('.recently-viewed .custom-select select').style.border = 'none';
              document.querySelector('.recently-viewed #select-bestsellers').selected = 'selected';
              document.querySelector('.recently-viewed .pipe').style.display = 'none';
              document.querySelector('.recently-viewed input:checked + label').style.border= 'none';
              document.querySelector('.nav-tab1').style.display = 'none';
              document.querySelector('.nav-tab2').style.display = 'flex';
          }

          // Init section settings collection swiper
          const coll_swiper = new window.swiper('.best-sellers-swiper', {
            slidesPerView: 1.2,
            spaceBetween: 17,

            navigation: {
                nextEl: '.nav-tab2 .swiper-navigation--next',
                prevEl: '.nav-tab2 .swiper-navigation--previous',
            },

            lazy: {
                enabled: true,
                checkInView: true,
            },

            breakpoints: {
                575: {
                    slidesPerView: 2.2,
                },
                768: {
                    slidesPerView: 3.2,
                    spaceBetween: 13
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 13
                }
            },
          });
      }


  }, options)

  observer.observe(recently_viewed_section)
});
